import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

class TruckerReg extends Component {
    state = { 
        regStatus:false
     }
    render() { 
        return ( 
            <div className="full-div">
                {this.changeRoute()}
                <div className="hero-min">
                    <div className="spacer"></div>
                    <div className="hero-min-topic">
                        <h2>Almost done {sessionStorage.getItem('name')}</h2>
                        <p>Complete Your registration</p>
                        <p>
                            . <br/><br/><br/>
                        </p>
                    </div>
                </div>
                <div className="reg-sect" data-aos="fade-up">
                    <div className="reg-form">
                        <div className="reg-logo">
                            <img src={require("./../images/reg-logo.png")} width="100%" alt=""/>
                        </div>
                        <form id="reg_form" name="reg_form">
                            <label>Id Type</label><br/>
                            <select form="reg_form" id="idtype" required>
                                <option className="disabled-option" value="0"> Select an Option</option>
                            </select><br/>
                            <label>ID number</label><br/>
                            <input type="text" placeholder="Enter Id number" id="idnumber" required/><br/>
                            <label>Truck Type</label><br/>
                            <select form="reg_form" id="trucktype" required>
                                <option className="disabled-option" value="0"> Select an Option</option>
                            </select><br/>
                            <label>Association number</label><br/>
                            <input type="text" placeholder="Enter assosiation number" id="ass_number" required/><br/>
                            <label>Card issue date</label><br/>
                            <input type="date" placeholder="Enter card issue date" id="iss_date"  required/><br/>
                            <label>Id expiry date</label><br/>
                            <input type="date" placeholder="Enter expiry date" id="exp_date"/><br/>
                            <label>Plate number</label><br/>
                            <input type="text" placeholder="Enter plate number" id="plate_number" required/><br/>
                            <label>Address</label><br/>
                            <input type="text" placeholder="enter address" id="address" required/><br/>
                            <label>Photo</label><br/>
                            <input type="file" placeholder="enter address" id="photo" required/><br/>
                            <div className="submiter">
                            <p><span className="warning"></span></p>
                            <input type="submit" value="Register"/>
                            </div>{/* 
                            id user id,
                            idtype selected id type
                            idnumber string
                            trucktype integer (selected truck type)
                            ass_number string (association number)
                            exp_date timestamp (id exp date) optional
                            iss_date timestamp (id issued date) 
                            plate_number string
                            address string */}
                        </form>
                    </div>
                </div>
            </div>
         );
    }
    
    componentDidMount(){
        window.scrollTo(0, 0);
        const registerForm = document.getElementById('reg_form');
        registerForm.addEventListener('submit', (e)=>{
            this.submitFunction(e)
        });
        this.checkId();
        this.checkTruck();
        let idtype = document.getElementById('idtype');
        idtype.addEventListener('focus', e => {
            let disOpt = idtype.querySelector('.disabled-option');
            disOpt.disabled = true;
        })
        let trucktype = document.getElementById('trucktype');
        trucktype.addEventListener('focus', e => {
            let disOpt = trucktype.querySelector('.disabled-option');
            disOpt.disabled = true;
        })
    }
    submitFunction = (e)=>{
        e.preventDefault();
        const submitButton = document.querySelector('.submiter input')
        submitButton.value = 'Processing. . .'
        let idtype = document.getElementById('idtype');
        let idnumber = document.getElementById('idnumber');
        let trucktype = document.getElementById('trucktype');
        let ass_number = document.getElementById('ass_number');
        let exp_date = document.getElementById('exp_date');
        let iss_date = document.getElementById('iss_date');
        let plate_number = document.getElementById('plate_number');
        let address = document.getElementById('address');
        let photo = document.getElementById('photo');
        
        if(idtype.value == 0){
            submitButton.value = 'Register';
            this.warnUser('Pick an ID type');
            idtype.focus();
            return false;
        }
        if(trucktype.value == 0){
            submitButton.value = 'Register';
            this.warnUser('Pick a truck type');
            trucktype.focus();
            return false;
        }
        let formD = new FormData();
        formD.append('id', sessionStorage.getItem('id'));
        formD.append('idtype', idtype.value);
        formD.append('idnumber', idnumber.value);
        formD.append('trucktype', trucktype.value);
        formD.append('ass_number', ass_number.value);
        formD.append('exp_date', exp_date.value);
        formD.append('iss_date', iss_date.value);
        formD.append('plate_number', plate_number.value);
        formD.append('address', address.value);
        formD.append('image', photo.files[0]);


        let image;
        let reader = new FileReader();
        reader.onload = function (e) {
            image = e.target.result;
        }
        reader.readAsDataURL(photo.files[0])
        setTimeout(()=>{
            let data = {
                id:sessionStorage.getItem('id'),
                idtype:idtype.value,
                idnumber:idnumber.value,
                trucktype:trucktype.value,
                ass_number:ass_number.value,
                exp_date:exp_date.value,
                iss_date:iss_date.value,
                plate_number:plate_number.value,
                address:address.value,
                image:image
            }
            //console.log(formD)
            fetch('https://portal.towva.co/api/finish_registration',{
                method:'POST',
                body:formD,
                headers:{
                    'Authorization':`Bearer ${sessionStorage.getItem('token')}`
                }
            })
            .then(res=> res.json())
            .then(res => {
                submitButton.value = 'Register';
                //console.log(res)
                if (res.errors){
                    //warningSpace.innerHTML = res.errors.tostring()
                    //console.log(res.errors)
                    if(res.errors.idtype){
                        this.warnUser(res.errors.idtype);
                        idtype.focus()
                    }else if(res.errors.idnumber){
                        this.warnUser(res.errors.idnumber);
                        idnumber.focus()
                    }else if(res.errors.trucktype){
                        this.warnUser(res.errors.trucktype);
                        trucktype.focus()
                    }else if(res.errors.ass_number){
                        this.warnUser(res.errors.ass_number);
                        ass_number.focus()
                    }else if(res.errors.exp_date){
                        this.warnUser(res.errors.exp_date);
                        exp_date.focus()
                    }else if(res.errors.iss_date){
                        this.warnUser(res.errors.iss_date);
                        iss_date.focus()
                    }else if(res.errors.plate_number){
                        this.warnUser(res.errors.plate_number);
                        plate_number.focus()
                    }else if(res.errors.address){
                        this.warnUser(res.errors.address);
                        address.focus()
                    }else{
                        this.warnUser('Invalid details entered.')
                    }
                }else{
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('id');
                    sessionStorage.setItem('name2', sessionStorage.getItem('name'));
                    sessionStorage.removeItem('name');
                    //let { regStatus } = this.state;
                    this.setState({regStatus:true});
                }
            })
            .catch(err=>{
                //console.log(err);
                submitButton.value = 'Register';
                this.warnUser('Invalid details')
                //fName.value = '';
                //lName.value = '';;
            })
        },500)
    }
    checkId(){
        fetch('https://portal.towva.co/api/idtype',{
            method:'GET',
            headers:{
                'Content-type':'Application/json',
                'Access-Control-Allow-Origin':'*'
            }
        })
        .then(res => res.json())
        .then(res =>{
            let data =res;
            let idtype = document.getElementById('idtype');
            for(let i = 0; i < data.length; i++){
                idtype.innerHTML += `<option value="${data[i].id}">${data[i].name}</option>`
            }
        })
    }
    checkTruck(){
        fetch('https://portal.towva.co/api/trucktypes',{
            method:'GET',
            headers:{
                'Content-type':'Application/json',
                'Access-Control-Allow-Origin':'*'
            }
        })
        .then(res => res.json())
        .then(res =>{
            let data =res;
            let trucktype = document.getElementById('trucktype');
            for(let i = 0; i < data.trucktypes.length; i++){
                trucktype.innerHTML += `<option value="${data.trucktypes[i].id}">${data.trucktypes[i].name}</option>`
            }
        })
    }
    changeRoute(){
        if(this.state.regStatus === true){
            return <Redirect to='/congratulations'/>
        } 
        if(!sessionStorage.getItem('token')){
            return <Redirect to='/trucker-registration'/>
        }
    }
    //Display warning message for four (4) seconds
    warnUser(arg){
        let warningSpace = document.querySelector('.warning');
        warningSpace.innerHTML = arg;
        setTimeout(()=>{
            warningSpace.innerHTML = '';
        }, 4000)
    }
}
 
export default TruckerReg;